import React from 'react';
import { ArrowTopRightOnSquareIcon } from '@heroicons/react/24/outline';

export default function KnowledgeGraphTab({ url }) {
  return (
    <div className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden session-graph-panel">
      <div className="flex items-center justify-between px-5 py-4 border-b">
        <h3 className="text-lg font-semibold text-gray-900">Knowledge graph</h3>
        <a href={url} target="_blank" rel="noopener noreferrer" className="session-btn session-btn-ghost">
          <ArrowTopRightOnSquareIcon />
          Open in new tab
        </a>
      </div>
      <iframe title="knowledge-graph" src={url} className="w-full session-graph-frame" />
    </div>
  );
}
